module.exports = __webpack_public_path__ + "static/media/electronic-bill.1e97709b.png";